module.exports = __webpack_public_path__ + "static/media/MacPortraitw300@1x.4d5474af.webp";